import { render, staticRenderFns } from "./CorporatePoliciesCategoriesCard.vue?vue&type=template&id=6051da40&"
import script from "./CorporatePoliciesCategoriesCard.vue?vue&type=script&lang=js&"
export * from "./CorporatePoliciesCategoriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports